import React from 'react';
import { Dialog } from '@mui/material';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MorphologyStore } from '../MorphologyStore';
import '../../shared/RevealConfirmationDialog/RevealConfirmationDialog.less';
import { getTodaysDateLabel } from '../morphologyUtils';

const MobileMorphologyAbout = () => {
  const isOpen = MorphologyStore.useState(s => s.toolbar.aboutIsOpen);
  const author = MorphologyStore.useState(s => s.author);

  const onClose = () => {
    MorphologyStore.update(s => {
      s.toolbar.aboutIsOpen = false;
    });
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <div className="revealConfirmationDialogContent">
        <IconButton className="closeButton" onClick={onClose}>
          <CloseIcon/>
        </IconButton>
        <div className="aboutBody">
          {getTodaysDateLabel()}
          <br/>
          <br/>
          Today's puzzle by {author}.
        </div>
      </div>
    </Dialog>
  );
};

export default MobileMorphologyAbout;